module.exports = __webpack_public_path__ + "assets/img/block-2753917f.png";